import { Box, Typography } from '@mui/material';
import { getWorkflowNodeIcon } from '@/utils/getWorkflowNodeIcon';
import { getTaskTypeLabel, getWorkflowTypeLabel } from '@/utils/workflowBreakdownUtils';

type ActionBreakdownItem = {
  name: string;
  type?: string;
  workflow_type?: string;
};

type WorkflowBreakdownTooltipProps = {
  active?: boolean;
  payload?: Array<{ payload: ActionBreakdownItem }>;
  coordinate?: { x?: number; y?: number };
};

export default function WorkflowBreakdownTooltip({ active, payload }: WorkflowBreakdownTooltipProps) {
  if (!active || !payload?.length) {
    return null;
  }

  const item = payload[0].payload;
  const workflowLabel = getWorkflowTypeLabel(item.workflow_type);
  const taskTypeLabel = getTaskTypeLabel(item.type);
  const icon = getWorkflowNodeIcon(item.type, 32);

  return (
    <Box
      sx={{
        position: 'relative',
        transform: 'translate(-50%, calc(-100% - 12px))',
        pointerEvents: 'none',
        bgcolor: '#fff',
        border: '1px solid #ECECEC',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        px: 1.5,
        py: 1.25
      }}
    >
      <Box display='flex' alignItems='center' gap={1.25}>
        {icon && (
          <Box display='flex' alignItems='center' justifyContent='center' flexShrink={0}>
            {icon}
          </Box>
        )}
        <Box>
          {workflowLabel && (
            <Typography fontWeight={500} fontSize={13} lineHeight={1.3}>
              {workflowLabel}
            </Typography>
          )}
          {taskTypeLabel && (
            <Typography fontSize={12} color='#9CA3AF' lineHeight={1.4} mt={workflowLabel ? 0.25 : 0}>
              Task Type: {taskTypeLabel}
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          bottom: -7,
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '7px solid transparent',
          borderRight: '7px solid transparent',
          borderTop: '7px solid #fff'
        }}
      />
    </Box>
  );
}
